import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { DateTime } from 'luxon';
import type { ChancenwerkUser } from '../../master-data-management/users/entities/ChancenwerkUser.js';
import { Comment } from '../entities/Comment.js';

export const createComment = registerMutation({
  type: () => String,
  operationName: 'createComment',
  resolve: (roomID: string, text: string) => {
    return async () => {
      if (text.length <= 1) {
        throw new Error('Text ist zu kurz');
      }

      const user = await CurrentUserInfo.getMyself<ChancenwerkUser>()({
        roles: { name: 1, permissions: 1, contexts: 1 },
      });

      if (!user) {
        throw new Error('User not found');
      }

      return await new Comment({
        roomID,
        text,
        userID: user._id,
        createdAt: DateTime.now(),
      }).create();
    };
  },
  options: {},
  params: [
    { type: () => String, name: 'roomID' },
    { type: () => String, name: 'text' },
  ],
});
